export class CreateLocalDVRRequestBody {
  public uploadRequestId: string;
  public unitSystem?: string;
  public videoResolution?: string;
  public dvrVideoType?: string;
  public dvrVideoTypeMainFrame?: string;
  public dvrInitiatedMetadata?: any;

  constructor({
    uploadRequestId,
    unitSystem,
    videoResolution,
    dvrVideoType,
    dvrVideoTypeMainFrame,
    dvrInitiatedMetadata,
  }: {
    uploadRequestId: string;
    unitSystem?: string;
    videoResolution?: string;
    dvrVideoType?: string;
    dvrVideoTypeMainFrame?: string;
    dvrInitiatedMetadata?: any;
  }) {
    this.uploadRequestId = uploadRequestId;
    this.unitSystem = unitSystem;
    this.videoResolution = videoResolution;
    this.dvrVideoType = dvrVideoType;
    this.dvrVideoTypeMainFrame = dvrVideoTypeMainFrame;
    this.dvrInitiatedMetadata = dvrInitiatedMetadata;

    if (dvrVideoType !== 'pictureInPicture') {
      delete this.dvrVideoTypeMainFrame;
    }
  }
}

export interface UploadRequest {
  uploadRequestId: string;
  dvrVideoTags: string[];
}
export interface UpdateDvrMetaDataParams {
  tripId: string;
  driverId: string;
  fleetId: string;
  uploadRequests: UploadRequest[];
}

export interface DvrTags {
  tagId?: number;
  tagName?: string;
  entityName?: string;
  attributeId?: number;
  attributeName?: string;
  attributeType?: string;
  attributeStatus?: string;
}

export interface EventTags {
  tagId?: number;
  tagName?: string;
  entityName?: string;
  attributeId?: number;
  attributeName?: string;
  attributeType?: string;
  extTagId?: number;
  rootTagId?: number;
  tagStatus?: string;
  disabled?: boolean;
}

export class LocalDVRDetails {
  driverId: String;
  assetId: String;
  driverName: String;
  duration: String;
  startTimeUTC: String;
  videoQuality: String;
  startTime: string;
  endTime: string;
}

export enum VideoRequestsPageEventType {
  DVR = 'DVRUpload',
  PANIC_BUTTON = 'Custom-Triggered',
  EDVR = 'edvr',
}

export interface VideoRequestsPageQueryParams {
  startTimeUTC?: string;
  endTimeUTC?: string;
  eventType?: VideoRequestsPageEventType;
  tripId?: string;
  driverId?: string;
  eventIndex?: string;
  uploadRequestId?: string;
}
